import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Alert, Spinner } from "reactstrap";
import {
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../../../../../components/Component";
import { useDispatch, useSelector } from "react-redux";
import {
  fail_branch_location_list,
  loading_branch_location_list,
  reset_branch_location_list,
  success_branch_location_list,
} from "../../../../../../reducers/dashboard_reducers/branch_locations/branch_location_list_Slice";
import {
  CREATE_GOODS_RECEIVED_TICKET_ACCESS_DENIED_MSG,
  CREATE_GOODS_RECEIVED_TICKET_ERR_MSG,
  CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG,
  RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG,
  RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG,
  RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG,
  RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG,
} from "../../../../../../constants/success_error_messages_consts";
import {
  CREATE_WAREHOUSE_DELIVERY_GRN_API,
  RETRIEVE_ACTIVE_EMPLOYEE_BRANCH_LOCATION_LIST_API,
  RETRIEVE_ACTIVE_USER_ACCOUNT_LIST,
} from "../../../../../../api/api_data";
import { messageToast } from "../../../../../../utils/Utils";
import { employee_dashboard_actions_helper } from "../../../../../../actions/actions_helper";
import * as app_consts from "../../../../../../constants/react_app_consts";
import { useNavigate } from "react-router-dom";
import {
  fail_user_accounts_list,
  loading_user_accounts_list,
  reset_user_accounts_list,
  success_user_accounts_list,
} from "../../../../../../reducers/dashboard_reducers/user_accounts/user_accounts_list_Slice";
import {
  getSelectedOption,
  removeWhitespaceAndCapitalize,
} from "../../../../../../utils/functionalUtils";
import TextInput from "../../../../../components/inputs/TextInput";
import {
  fail_create_goods_recieved_ticket,
  loading_create_goods_recieved_ticket,
  reset_create_goods_recieved_ticket,
  success_create_goods_recieved_ticket,
} from "../../../../../../reducers/dashboard_reducers/warehouse/create_goods_received_ticket_Slice";

const initialState = {
  branch_location_id: "",
  consigner_type: "",
  user_account_id: "",
  transporter_name: "",
  truck_driver_name: "",
  truck_licence_plate: "",
  trailer_one: "",
  trailer_two: "",
  contract_number: "",
  other_consigner_name: "",
  comments: "",
};

const AddGRNModal = ({ successFunction, setModalLoading, openModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [errorVal, setError] = useState("");
  const [branches_data, setBranchesData] = useState([]);
  const [branches_loading, setBranchesLoading] = useState(true);
  const [formData, setFormData] = useState(initialState);
  const [consigner_loading, setConsignerLoading] = useState(true);
  const [current_consigner_list, setCurrentConsingerList] = useState([]);
  const [company_consigner_list, SetCompanyConsignerList] = useState([]);
  const [customer_consigner_list, SetCustomerConsignerList] = useState([]);

  useEffect(() => {
    if (openModal)
    {
      fetch_active_branch_location_list();
      fetchActiveConsigners();
      setFormData(initialState);
    }
  }, [openModal]);

  const fetch_active_branch_location_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_branch_location_list,
        success_branch_location_list,
        fail_branch_location_list,
        RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG,
        RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_EMPLOYEE_BRANCH_LOCATION_LIST_API,
        null,
        RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  const branch_location_list = useSelector(
    (state) => state.branch_location_list.branch_location_list
  );

  useEffect(() => {
    if (branch_location_list.status !== app_consts.IDLE)
    {
      if (branch_location_list.status === app_consts.LOADING)
      {
        setBranchesLoading(true);
      } else
      {
        setBranchesLoading(false);
        if (branch_location_list.status === app_consts.FAIL)
        {
          messageToast(branch_location_list.message, app_consts.FAIL);
        } else if (branch_location_list.status === app_consts.SUCCESS)
        {
          const remapped_data = branch_location_list.data?.map((branch) => {
            return {
              label: `${branch.branch_area} - ${branch.province_name}`,
              value: branch.branch_location_id,
            };
          });
          setBranchesData(remapped_data);
        }
        dispatch(reset_branch_location_list());
      }
    }
  }, [branch_location_list]);

  const handleConsignerSelection = (value) => {
    if (value === app_consts.COMPANY_CONSIGNER_STRING)
    {
      setCurrentConsingerList(company_consigner_list);
    } else if (value === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      setCurrentConsingerList(customer_consigner_list);
    } else
    {
      setCurrentConsingerList([]);
    }
    setFormData({
      ...formData,
      consigner_type: value,
      user_account_id: "",
      other_consigner_name: "",
    });
  };

  const fetchActiveConsigners = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_user_accounts_list,
        success_user_accounts_list,
        fail_user_accounts_list,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST,
        null,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  const user_accounts_list = useSelector(
    (state) => state.user_accounts_list.user_accounts_list
  );

  useEffect(() => {
    if (user_accounts_list.status !== app_consts.IDLE)
    {
      if (user_accounts_list.status === app_consts.LOADING)
      {
        setConsignerLoading(true);
      } else
      {
        setConsignerLoading(false);
        if (user_accounts_list.status === app_consts.FAIL)
        {
          messageToast(user_accounts_list.message, app_consts.FAIL);
        } else if (user_accounts_list.status === app_consts.SUCCESS)
        {
          const remapped_company_data =
            user_accounts_list?.data?.company_accounts?.map((data) => {
              return {
                value: data.unique_identification_number,
                label: `${data.unique_identification_number} - ${data.company_name}`,
              };
            });
          const remapped_customer_data =
            user_accounts_list?.data?.customer_accounts?.map((data) => {
              return {
                value: data.unique_identification_number,
                label: `${data.unique_identification_number} - ${data.first_name} ${data.surname}`,
              };
            });
          SetCustomerConsignerList(remapped_customer_data);
          SetCompanyConsignerList(remapped_company_data);
        }
        dispatch(reset_user_accounts_list());
      }
    }
  }, [user_accounts_list]);

  const handleChange = (e) => {
    let change_value = e.target.value;
    if (
      e.target.name === "truck_licence_plate" ||
      e.target.name === "trailer_one" ||
      e.target.name === "trailer_two"
    )
    {
      change_value = removeWhitespaceAndCapitalize(e.target.value);
    }
    setFormData({ ...formData, [e.target.name]: change_value });
  };

  const handleCreateGRN = () => {
    setError("");
    dispatch(
      employee_dashboard_actions_helper(
        loading_create_goods_recieved_ticket,
        success_create_goods_recieved_ticket,
        fail_create_goods_recieved_ticket,
        CREATE_GOODS_RECEIVED_TICKET_ERR_MSG,
        CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG,
        app_consts.POST,
        CREATE_WAREHOUSE_DELIVERY_GRN_API,
        formData,
        CREATE_GOODS_RECEIVED_TICKET_ACCESS_DENIED_MSG
      )
    );
  };

  const create_goods_recieved_ticket = useSelector(
    (state) =>
      state.create_goods_recieved_ticket.create_goods_recieved_ticket
  );

  useEffect(() => {
    if (create_goods_recieved_ticket.status !== app_consts.IDLE)
    {
      if (create_goods_recieved_ticket.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (create_goods_recieved_ticket.status === app_consts.FAIL)
        {
          setError(create_goods_recieved_ticket.message);
          messageToast(create_goods_recieved_ticket.message, app_consts.FAIL);
        } else if (create_goods_recieved_ticket.status === app_consts.SUCCESS)
        {
          messageToast(
            CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG,
            app_consts.SUCCESS
          );
          navigate(
            `/dashboard/goods_received/${create_goods_recieved_ticket?.data?.goods_received_ref_number}`
          );
        }
        dispatch(reset_create_goods_recieved_ticket());
      }
    }
  }, [create_goods_recieved_ticket]);

  return (
    <motion.form
      onSubmit={(e) => e.preventDefault()}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Row className="g-4">
        {/* Contract */}
        <TextInput
          label="Contract Number"
          required
          type="text"
          id_val="contract_number"
          maxlength="100"
          value={formData.contract_number}
          handleChange={handleChange}
          colSize="4"
          name="contract_number"
        />

        {/* Branch location */}
        <Col size={4}>
          <motion.div
            className="form-group"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="d-flex justify-between align-items-center">
              <label
                className="form-label text-md"
                htmlFor="branch_location_id"
              >
                Warehouse Location
                <span className="text-danger pr-2">{` *`}</span>
              </label>
              {branches_loading && <Spinner size="sm" />}
            </div>
            <RSelect
              options={branches_data}
              className="w-100"
              placeholder="Search"
              id="branch_location_id"
              onChange={(e) =>
                setFormData({ ...formData, branch_location_id: e.value })
              }
              isDisabled={branches_loading}
            />
          </motion.div>
        </Col>

        {/* Consigner type */}
        <Col size={4}>
          <div className="form-group">
            <label className="form-label text-md">Supplier<span className="text-danger pr-2">{` *`}</span></label>
            <RSelect
              options={[
                { value: app_consts.UAG_CONSIGNER_STRING, label: "UAG" },
                { value: app_consts.COMPANY_CONSIGNER_STRING, label: "Company" },
                { value: app_consts.CUSTOMER_CONSIGNER_STRING, label: "Individual Customer" },
                { value: app_consts.OTHER_CONSIGNER_STRING, label: "Other" },
              ]}
              className="w-100"
              placeholder="Search"
              id="consigner_type"
              onChange={(e) => handleConsignerSelection(e.value)}
              isDisabled={consigner_loading}
            />
          </div>
        </Col>

        {/* Supplier Details */}
        {(formData?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING ||
          formData?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING) && (
            <Col size={4}>
              <motion.div
                className="form-group"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <label className="form-label text-md">Supplier Details<span className="text-danger pr-2">{` *`}</span></label>
                {consigner_loading && <Spinner size="sm" />}
                <RSelect
                  options={current_consigner_list}
                  className="w-100"
                  placeholder="Search"
                  id="user_account_id"
                  onChange={(e) =>
                    setFormData({ ...formData, user_account_id: e.value })
                  }
                  isDisabled={consigner_loading}
                  value={getSelectedOption(
                    formData?.user_account_id,
                    current_consigner_list
                  )}
                />
              </motion.div>
            </Col>
          )}

        {formData?.consigner_type === app_consts.OTHER_CONSIGNER_STRING && (
          <TextInput
            colSize={4}
            label="Supplier Details"
            required
            type="text"
            id_val="other_consigner_name"
            value={formData.other_consigner_name}
            handleChange={handleChange}
            name="other_consigner_name"
          />
        )}

        {/* Truck Details */}
        <div className="form-label-group">
          <label className="form-label text-soft fs-18px">Truck Details</label>
        </div>
        <TextInput
          colSize={4}
          label="Transporter"
          required
          type="text"
          id_val="transporter_name"
          value={formData.transporter_name}
          handleChange={handleChange}
          name="transporter_name"
        />
        <TextInput
          colSize={4}
          label="Truck Driver"
          required
          type="text"
          id_val="truck_driver_name"
          value={formData.truck_driver_name}
          handleChange={handleChange}
          name="truck_driver_name"
        />
        <TextInput
          colSize={4}
          label="Truck Horse Reg No."
          required
          type="text"
          id_val="truck_licence_plate"
          value={formData.truck_licence_plate}
          handleChange={handleChange}
          name="truck_licence_plate"
        />
        <TextInput
          colSize={4}
          label="Trailer Reg 1 (Optional)"
          type="text"
          id_val="trailer_one"
          value={formData.trailer_one}
          handleChange={handleChange}
          name="trailer_one"
        />
        <TextInput
          colSize={4}
          label="Trailer Reg 2 (Optional)"
          type="text"
          id_val="trailer_two"
          value={formData.trailer_two}
          handleChange={handleChange}
          name="trailer_two"
        />

        {/* Comments */}
        <Col size="12">
          <div className="form-group">
            <label className="form-label text-md" htmlFor="comments">
              Comments (Optional)
            </label>
            <textarea
              className="no-resize form-control"
              id="comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
            />
          </div>
        </Col>

        {/* Error Alert */}
        {errorVal && (
          <motion.div
            className="mb-3 w-100"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <Alert color="danger" className="alert-icon">
              <Icon name="alert-circle" /> {errorVal}
            </Alert>
          </motion.div>
        )}

        {/* Submit */}
        <Col xl="12">
          <div className="form-group text-right">
            <Button
              onClick={handleCreateGRN}
              disabled={
                loading
                  ? loading
                  : !(
                    formData?.consigner_type &&
                    formData?.branch_location_id &&
                    formData?.contract_number &&
                    formData?.truck_driver_name &&
                    formData?.truck_licence_plate &&
                    formData?.transporter_name &&
                    (formData?.consigner_type === app_consts.UAG_CONSIGNER_STRING
                      ? true
                      : formData?.consigner_type === app_consts.OTHER_CONSIGNER_STRING
                        ? formData?.other_consigner_name
                        : formData?.user_account_id)
                  )
              }
              color="primary"
              size="md"
            >
              {loading ? <Spinner size="sm" color="light" /> : "Add GRN"}
            </Button>
          </div>
        </Col>
      </Row>
    </motion.form>
  );
};

export default AddGRNModal;
